var DEFAULT_PORT_POSITION = 'right';
var DEFAULT_PORT_TYPE = 'output';
var DEFAULT_PORT_DIRECTION = 'right';
var DEFAULT_PORT_CONNECTOR = 'head';

var VALID_POSITIONS = ['center', 'left', 'right', 'top', 'bottom'];
var VALID_DIRECTIONS = ['right', 'left'];
var VALID_CONNECTORS = ['head', 'tail', 'tip'];

function cloneJson(value) {
  if (typeof value === 'undefined') return undefined;
  return JSON.parse(JSON.stringify(value));
}

function trimString(value) {
  return typeof value === 'string' ? value.trim() : '';
}

function getServiceClass(record) {
  if (!record || typeof record !== 'object') return '';
  return trimString(record.serviceClass || record.category || record.class);
}

function setServiceClass(record, serviceClass) {
  if (!record || typeof record !== 'object') return record;
  var normalizedServiceClass = trimString(serviceClass);
  if (!normalizedServiceClass) return record;
  record.serviceClass = normalizedServiceClass;
  record.class = normalizedServiceClass;
  return record;
}

function normalizePortType(position, type) {
  if (position === 'center') return 'bidirectional';
  return type === 'input' || type === 'output' ? type : DEFAULT_PORT_TYPE;
}

function normalizePortId(id, fallbackId) {
  if (typeof id === 'number' && Number.isFinite(id)) return id;
  if (typeof id === 'string' && id.trim()) return id.trim();
  return fallbackId;
}

function normalizeChoice(value, allowedValues, fallbackValue) {
  var normalized = trimString(value);
  return allowedValues.indexOf(normalized) === -1 ? fallbackValue : normalized;
}

function buildPortDefinition(portData, options) {
  var opts = options || {};
  var port = Object.assign({}, cloneJson(portData || {}));
  var fallbackServiceClass = trimString(opts.fallbackServiceClass);
  var position = normalizeChoice(port.position, VALID_POSITIONS, DEFAULT_PORT_POSITION);
  var serviceClass = getServiceClass(port) || fallbackServiceClass;

  port.name = trimString(port.name);
  port.id = normalizePortId(port.id, opts.fallbackId || 1);
  port.position = position;
  port.type = normalizePortType(position, port.type);
  port.direction = normalizeChoice(port.direction, VALID_DIRECTIONS, DEFAULT_PORT_DIRECTION);
  port.connector = normalizeChoice(port.connector, VALID_CONNECTORS, DEFAULT_PORT_CONNECTOR);

  if (serviceClass) {
    setServiceClass(port, serviceClass);
  }

  return port;
}

function portListValues(ports) {
  return Array.isArray(ports) ? ports : Object.values(ports || {});
}

function nextPortId(ports) {
  var ids = portListValues(ports)
    .map(function (port) {
      return Number(port && port.id);
    })
    .filter(Number.isFinite);
  return ids.length > 0 ? Math.max.apply(null, ids) + 1 : 1;
}

function normalizePortDefinitions(ports, options) {
  var opts = options || {};
  return portListValues(ports).map(function (port, index) {
    return buildPortDefinition(port, {
      fallbackId: index + 1,
      fallbackServiceClass: opts.fallbackServiceClass
    });
  });
}

function pushUnique(errors, message) {
  if (errors.indexOf(message) === -1) errors.push(message);
}

function validatePortDefinitions(ports, options) {
  var errors = [];
  normalizePortDefinitions(ports, options).forEach(function (port) {
    if (!port.name) {
      pushUnique(errors, "Ports can't be empty.");
    }
    if (!port.type) {
      pushUnique(errors, 'Port type is required.');
    }
    if (!getServiceClass(port)) {
      pushUnique(errors, 'Port service class is required.');
    }
  });
  return errors;
}

module.exports = {
  DEFAULT_PORT_CONNECTOR: DEFAULT_PORT_CONNECTOR,
  DEFAULT_PORT_DIRECTION: DEFAULT_PORT_DIRECTION,
  DEFAULT_PORT_POSITION: DEFAULT_PORT_POSITION,
  DEFAULT_PORT_TYPE: DEFAULT_PORT_TYPE,
  buildPortDefinition: buildPortDefinition,
  getServiceClass: getServiceClass,
  nextPortId: nextPortId,
  normalizePortDefinitions: normalizePortDefinitions,
  normalizePortType: normalizePortType,
  setServiceClass: setServiceClass,
  validatePortDefinitions: validatePortDefinitions
};
